import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { PostClient } from '../services/httpServices';

import styled from '@emotion/styled';

// import { TextField } from '@material-ui/core';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const CreateClient = (props) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [posting, setPosting] = useState(false);

  const [clientType, setClientType] = useState('New Client');
  const [martialStatus, setMartialStatus] = useState('Married');
  const [applicationType, setApplicationType] = useState('New Work Permit');

  const fullNameRef = useRef('');
  const dateOfBirthRef = useRef('');
  const placeOfBirthRef = useRef('');
  const citizenshipRef = useRef('');
  const currentCountryRef = useRef('');
  const statusRef = useRef('');
  const statusFromRef = useRef('');
  const statusToRef = useRef('');
  const residentialAddressRef = useRef('');
  const phoneNumberRef = useRef('');
  const altCntctNumRef = useRef('');
  const faxNumRef = useRef('');
  const emailRef = useRef('');
  const marriageDateRef = useRef('');
  const partnerNameRef = useRef('');
  const passportNumberRef = useRef('');
  const passportExpiryRef = useRef('');
  const fileNumberRef = useRef('');
  const applicationNumberRef = useRef('');
  const uCINumberRef = useRef('');

  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      clientType: clientType,
      applicationType: applicationType,
      fullName: fullNameRef.current.value,
      dateOfBirth: dateOfBirthRef.current.value,
      placeOfBirth: placeOfBirthRef.current.value,
      citizenship: citizenshipRef.current.value,
      currentCountry: currentCountryRef.current.value,
      status: statusRef.current.value,
      statusFrom: statusFromRef.current.value,
      statusTo: statusToRef.current.value,
      residentAddress: residentialAddressRef.current.value,
      phoneNumber: phoneNumberRef.current.value,
      altCntctNum: altCntctNumRef.current.value,
      faxNum: faxNumRef.current.value,
      email: emailRef.current.value,
      martialStatus: martialStatus,
      marriageDate: marriageDateRef.current.value,
      partnerName: partnerNameRef.current.value,
      passportNo: passportNumberRef.current.value,
      expiryDate: passportExpiryRef.current.value,
      ucinumber: uCINumberRef.current.value,
      applicationNumber: applicationNumberRef.current.value,
      fileNumber: fileNumberRef.current.value,
    };

    //console.log(payload);
    //console.log('Payload:', payload);
    let response = await PostClient(payload);
    console.log('PostResponse:', response);

    if (response.status == 200) {
      props.setMessage('Client has been created successfully.');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/ClientTabs/${response.data.id}/${true}`);
      }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setPosting(false);
      setLoading(false);
    }
  };

  const handleChangeClientType = (event) => {
    setClientType(event.target.value);
  };
  const handleChangeApplictionType = (event) => {
    setApplicationType(event.target.value);
  };
  const handleChangeMartialStatus = (event) => {
    setMartialStatus(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Client Type:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={clientType}
                        onChange={handleChangeClientType}
                      >
                        <FormControlLabel value="New Client" control={<Radio />} label="New Client" />
                        <FormControlLabel value="Existing Client" control={<Radio />} label="Existing Client" />
                        <FormControlLabel value="Returning Client" control={<Radio />} label="Returning Client" />
                        <FormControlLabel value="Referral" control={<Radio />} label="Referral" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={8}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Type of Application:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={applicationType}
                        onChange={handleChangeApplictionType}
                        row={true}
                      >
                        <FormControlLabel value="New Work Permit" control={<Radio />} label="New Work Permit" />
                        <FormControlLabel value="Open Work Permit" control={<Radio />} label="Open Work Permit" />
                        <FormControlLabel value="Permanent Residence" control={<Radio />} label="Permanent Residence" />
                        <FormControlLabel
                          value="Work Permit Extension with"
                          control={<Radio />}
                          label="Work Permit Extension"
                        />
                        <FormControlLabel value="Same Employer" control={<Radio />} label="Same Employer" />
                        <FormControlLabel value="New Employer" control={<Radio />} label="New Employer" />
                        <FormControlLabel
                          value="Study/Visit to Work Permit "
                          control={<Radio />}
                          label="Study/Visit to Work Permit"
                        />
                        <FormControlLabel
                          value="Restoration of Status"
                          control={<Radio />}
                          label="Restoration of Status"
                        />
                        <FormControlLabel value="Visitor Visa" control={<Radio />} label="Visitor Visa" />
                        <FormControlLabel value="Visitor Visa Extension" control={<Radio />} label="Visitor Visa Extension" />
                        <FormControlLabel value="Spousal Open Work Permit" control={<Radio />} label="Spousal Open Work Permit" />
                        <FormControlLabel value="Super Visa" control={<Radio />} label="Super Visa" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Full Name (as per passport)"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={fullNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Passport Number"
                      // required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.passportNo}
                      inputRef={passportNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Passport Expiry Date"
                      type="date"
                      // required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.expiryDate?.split('T')[0]}
                      inputRef={passportExpiryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Date of Birth"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyInformations[0]?.revokedDate?.split('T')[0]}
                      // disabled={!lmiaRevoked}
                      inputRef={dateOfBirthRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Place of Birth"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={placeOfBirthRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Citizenship"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={citizenshipRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="File Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={fileNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="UCI Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={uCINumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Application Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={applicationNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Current Country of Residence"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={currentCountryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Status"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={statusRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="from:"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyInformations[0]?.revokedDate?.split('T')[0]}
                      // disabled={!lmiaRevoked}
                      inputRef={statusFromRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="To:"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyInformations[0]?.revokedDate?.split('T')[0]}
                      // disabled={!lmiaRevoked}
                      inputRef={statusToRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Residential Address"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={residentialAddressRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Phone Number"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={phoneNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Alternate Contact Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={altCntctNumRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Fax Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={faxNumRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Email Address"
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={company.companyName}
                      inputRef={emailRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Marital Status:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={martialStatus}
                        onChange={handleChangeMartialStatus}
                        row
                      >
                        <FormControlLabel value="Married" control={<Radio />} label="Married" />
                        <FormControlLabel value="Single" control={<Radio />} label="Single" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">If Married:</FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Marriage Date"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        //defaultValue={company.companyInformations[0]?.revokedDate?.split('T')[0]}
                        disabled={martialStatus == 'Married' ? false : true}
                        inputRef={marriageDateRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="Partner Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        //defaultValue={company.companyInformations[0].systemFileNumber}
                        disabled={martialStatus == 'Married' ? false : true}
                        inputRef={partnerNameRef}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}></Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" disabled={posting} variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default CreateClient;
